import { strInformation16, strTaskStar16 } from '../carbon-icons';

export type ContextControlNodeType = {
  id: string;
  label: string;
  icon: unknown;
  hideLabel: boolean;
  class: string;
};

export const CONTEXT_NODES: ContextControlNodeType[] = [
  {
    id: 'custom-recommended-print-position',
    hideLabel: false,
    label: 'Recommended print position',
    icon: strTaskStar16,
    class: '',
  },
  {
    id: 'custom-recommended-print-position-info',
    hideLabel: true,
    label: 'Recommended print position info',
    icon: strInformation16,
    class: '',
  },
];
